import React from 'react';

export const CompareArrows = () => (
  <svg
    width="57"
    height="50"
    viewBox="0 0 57 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M49.9059 20.0977H27.0225"
      stroke="#2ED3B7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.3683 28.4068L27.0225 20.0951L36.3683 11.7861"
      stroke="#2ED3B7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.99981 32.9673L29.8833 32.9673"
      stroke="#0084D2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5375 24.6581L29.8833 32.9699L20.5375 41.2788"
      stroke="#0084D2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
